import {
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST,
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS,
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST:
    case ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS:
      return null;

    case ACTION_LOAD_SITE_GOOGLE_ANALYTICS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
